import Select from './Select';
import SelectJson from './SelectJson';
import SelectJsonApi from './SelectJsonApi';
import Input from './Input';
import InputNumber from './InputNumber';
import DateTime from './DateTime';
import CheckBox from './CheckBox';
import Button from './Button';
import SwitchInput from './SwitchInput';
import Popup from './Popup';
import ButtonGen from './ButtonGen';
import ActionButton from './ActionButton';
import Notification from './Notification';
import ConfirmDialog from './ConfirmDialog';
import LinearProgressWithLabel from './LinearProgressWithLabel';
import InputSimple from './InputSimple';
import NumberDecimal from './NumberDecimal';

const Controls = {
  Select,
  Input,
  InputNumber,
  DateTime,
  CheckBox,
  Button,
  SelectJson,
  SwitchInput,
  Popup,
  ButtonGen,
  ActionButton,
  LinearProgressWithLabel,
  Notification,
  ConfirmDialog,
  InputSimple,
  NumberDecimal,
  SelectJsonApi
};

export default Controls;
